import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../client";

// Custom hooks
import useSession from "./useSessionManager";

const useLogIn = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const sessionManager = useSession();
  const navigate = useNavigate();

  const logInWithPassword = async (email, password) => {
    setErrorMessage(null);

    try {
      const { error, data } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;
      sessionManager.set(data);

      navigate("/redirect");
      window.location.reload();
    } catch (error) {
      console.log(error);
      setErrorMessage(error);
      throw error;
    }
  };

  return { logInWithPassword, errorMessage };
};

export default useLogIn;
